import { render, staticRenderFns } from "./DsrQuery.vue?vue&type=template&id=0be2fa15&scoped=true&"
import script from "./DsrQuery.vue?vue&type=script&lang=js&"
export * from "./DsrQuery.vue?vue&type=script&lang=js&"
import style0 from "./DsrQuery.vue?vue&type=style&index=0&id=0be2fa15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be2fa15",
  null
  
)

export default component.exports